import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {Banner, BannerTypesEnum} from '../../../../libs/shared/ui/src/components/banners/banner';
import {BannerCloseAction} from '../../../../libs/shared/ui/src/components/banners/bannerCloseAction';
import {BannerIcon} from '../../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../../libs/shared/ui/src/components/banners/bannersContext';
import {BannerText} from '../../../../libs/shared/ui/src/components/banners/bannerText';
import {
  AccountsInfoBannerState,
  AccountsInfoBannerTypesEnum,
} from '../../../store/panels/app/banners/bannersState';

/*
 * Props.
 */

interface AccountsInfoBannerProps {
  bannerState: AccountsInfoBannerState;
  onClose: () => void;
}

/*
 * Component.
 */

export const AccountsInfoBanner: FC<AccountsInfoBannerProps> = (props) => {
  const {bannerState, onClose} = props;

  return (
    <Banner bannerType={BannerTypesEnum.INLINE} priority={BannerPrioritiesEnum.TRANSIENT}>
      <BannerCloseAction onClick={onClose} />
      <BannerIcon iconName="briefcaseFilledSmall" />
      <BannerText>{getBannerText(bannerState)}</BannerText>
    </Banner>
  );
};

function getBannerText(bannerState: AccountsInfoBannerState) {
  switch (bannerState.accountsInfoType) {
    case AccountsInfoBannerTypesEnum.ACCOUNT_CREATED:
      return <Trans id="accounts-banner-account-created">Account created</Trans>;

    case AccountsInfoBannerTypesEnum.ACCOUNT_DELETED:
      return <Trans id="accounts-banner-account-deleted">Account deleted</Trans>;

    case AccountsInfoBannerTypesEnum.DOMAINS_UPDATED:
      return <Trans id="accounts-banner-domains-updated">Domains updated</Trans>;

    case AccountsInfoBannerTypesEnum.DOMAINS_REMOVED:
      return <Trans id="accounts-banner-domains-removed">Domains removed</Trans>;

    default:
      return null;
  }
}
